/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
import React, { useEffect, useRef, useState } from 'react';
import {
  Text,
  View,
  StyleSheet,
  Image,
  FlatList,
  Pressable,
} from 'react-native';
import { Modalize } from 'react-native-modalize';
import { useDispatch, useSelector } from 'react-redux';
import { getFormatedDate } from 'react-native-modern-datepicker-dayjs';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { imageCdn } from '~global/helpers';
const Button = React.lazy(() => import('@web-components/form/Button'));
import ProductPlaceholder from '@web-components/ProductPlaceholder';
import * as catalogActions from '~store/catalog/actions/catalog';
import Product from '@web-components/Product';
import ProductSlider from '@web-components/product/ProductSlider';
import PreOrderDeliveryDate from '@web-components/product/PreOrderDeliveryDate';
import WithLocalSvg from '@web-components/common/WithLocalSvg';
import { isWeb, isNative } from '~global/screens';
import Colors from '~global/Colors';
import { data as Font } from '~global/Fonts';
import ProductUtils from '~global/utils/product';

const defaultImage = require('~assets/img/dummy_product.png');
const iconBagSource = require('~assets/img/product/icon-bag-v2.png');
const iconBagBabyRegistrySource = require('~assets/img/baby-registry/icon-added-bag.png');
const maxContainer = 600;
const maxItemContainer = (maxContainer - 60) / 3;
// eslint-disable-next-line react/display-name
const ModalProductAdded = () => {
  const dispatch = useDispatch();
  const insets = useSafeAreaInsets();
  const modalizeRef = useRef(null);

  const [similarProducts, setSimilarProducts] = useState([]);
  const [similarProductsLoading, setSimilarProductsLoading] = useState(true);

  const isModalShow = useSelector((state) => state.modal.productAdded.isShow);
  const data = useSelector((state) => state.modal.productAdded.data);
  const baby_registry_id =
    data && data.baby_registry_id ? data.baby_registry_id : false;
  const productData = data && data.productData ? data.productData : '';
  const Utils = new ProductUtils(productData || {});
  const isBundleProduct = Utils.isBundleProduct();
  const preOrderDeliveryDate = isBundleProduct
    ? productData?.default_combination?.preorder?.[0]?.delivery_date
      ? getFormatedDate(
          new Date(
            productData?.default_combination?.preorder?.[0]?.delivery_date,
          ),
          'DD MMM YYYY',
        )
      : null
    : productData?.combinations && productData?.combinations[0]?.delivery_date
    ? getFormatedDate(
        new Date(productData?.combinations[0]?.delivery_date),
        'DD MMM YYYY',
      )
    : null;

  useEffect(() => {
    setSimilarProducts([]);
    setSimilarProductsLoading(true);
    if (productData.id) {
      dispatch(
        catalogActions.getSimilarProducts({
          limit: 10,
          filter: { id_product: productData.id },
        }),
      ).then((products) => {
        if (products && products.length) {
          setSimilarProducts(products);
        }
        setSimilarProductsLoading(false);
      });
    }
  }, [productData.id]);

  const openHandler = () => {
    modalizeRef.current?.open();
  };

  const closeHandler = () => {
    modalizeRef.current?.close();
  };

  useEffect(() => {
    isModalShow ? openHandler() : closeHandler();
  }, [isModalShow]);

  const setModalHide = () => {
    dispatch({ type: 'MODAL/HIDE', modalName: 'productAdded', data });
    resetData();
  };

  const resetData = (force) => {
    setTimeout(() => {
      if (force) {
        dispatch({ type: 'MODAL/HIDE', modalName: 'productAdded', data });
      }
      setSimilarProducts([]);
      setSimilarProductsLoading(true);
    }, 400);
  };

  const goToShoppingBag = () => {
    setModalHide();
    if (data.navigation.current) {
      return data.navigation.current.navigate('ShoppingBagScreen');
    }
    data.navigation.navigate('ShoppingBagScreen');
  };

  const goToBabyRegistry = () => {
    setModalHide();
    if (data.navigation.current) {
      return data.navigation.current.navigate('ShoppingBagScreen');
    }
    data.navigation.navigate('BabyRegistryScreen', {
      id: baby_registry_id,
    });
  };

  const coverImageSrc =
    productData && productData.images
      ? productData.images.filter((data) => data.is_cover)[0]
      : null;
  const coverImage =
    coverImageSrc && coverImageSrc.url
      ? imageCdn({
          config: isWeb ? 'w=156' : 'w=100',
          image: coverImageSrc.url,
        })
      : null;

  const renderItem = ({ item }) => {
    return (
      <Product
        productData={item}
        key={item._id}
        navigator={data.navigation}
        maxWidth={isWeb ? maxItemContainer : 0}
        isNoPaddingHorizontal={isWeb}
        productContainerStyle={styles.productContainerStyle}
      />
    );
  };

  const attributesName = () => {
    if (
      productData &&
      productData.combinations &&
      productData.combinations.length &&
      productData.combinations[0].attributes
    ) {
      const combinationAttributes =
        data.attributes ?? productData?.combinations[0]?.attributes;
      const name = [];
      for (const i in combinationAttributes) {
        name.push({
          group: i,
          value: combinationAttributes[i].name,
        });
      }
      return name;
    } else {
      return '';
    }
  };

  if (!productData) {
    return <></>;
  }

  return (
    <Modalize
      ref={modalizeRef}
      adjustToContentHeight={true}
      handleStyle={styles.handleStyle}
      modalStyle={styles.modalStyle}
      onClose={() => resetData(true)}>
      <View style={{ paddingBottom: insets.bottom }}>
        {baby_registry_id ? (
          <View
            style={[
              styles.modalProductSuccess,
              styles.modalProductSuccessBabyRegistry,
            ]}>
            <Image
              source={iconBagBabyRegistrySource}
              style={styles.modalProductIconBagRegistry}
              resizeMode="cover"
            />
            <View>
              <Text style={styles.modalProductRegistry}>
                Added to Registry!
              </Text>

              <Button
                title="Go to Your Registry"
                onPress={() => goToBabyRegistry()}
                buttonStyle={styles.modalProductShoppingButton}
                titleStyle={styles.modalProductShoppingButtonText}
              />
            </View>
            <Pressable
              style={styles.modalProductClose}
              onPress={() => setModalHide()}>
              <WithLocalSvg
                width={14}
                height={14}
                asset={require('~assets/img/product/icon-close.svg')}
              />
            </Pressable>
          </View>
        ) : (
          <View style={styles.modalProductSuccessAdded}>
            <Image
              source={iconBagSource}
              style={styles.modalProductIconBag}
              resizeMode="cover"
              width={38}
              height={50}
            />
            <Text style={styles.modalProductAdded}>Added to Bag!</Text>
            <Pressable
              style={styles.modalProductClose}
              onPress={setModalHide.bind(this)}>
              <WithLocalSvg
                width={14}
                height={14}
                asset={require('~assets/img/product/icon-close.svg')}
              />
            </Pressable>
          </View>
        )}

        <View style={styles.modalProductWrapper}>
          <View style={styles.productBorderBottom}>
            <View
              style={[
                styles.modalProductSummary,
                baby_registry_id ? styles.modalProductSummaryBabyRegistry : {},
              ]}>
              <Image
                source={{ uri: coverImage ? coverImage : null }}
                style={styles.modalProductImage}
                resizeMode="cover"
                defaultSource={defaultImage}
              />
              <View style={styles.modalProductInfo}>
                <Text
                  style={styles.modalProductBrand}
                  numberOfLines={1}
                  ellipsizeMode="tail">
                  {productData?.brand?.name}
                </Text>
                <Text
                  style={styles.modalProductName}
                  numberOfLines={1}
                  ellipsizeMode="tail">
                  {productData.name}
                </Text>
                <Text style={styles.modalProductCombination}>
                  {attributesName() &&
                    attributesName()
                      .filter((item) => item.group !== 'non_specify')
                      .map((res, index) => (
                        <Text key={index}>
                          <Text style={styles.modalProductCombinationGroup}>
                            {index > 0 ? ', ' : ''}
                            {res.group}:&nbsp;
                          </Text>
                          <Text style={styles.modalProductCombinationValue}>
                            {res.value}
                          </Text>
                        </Text>
                      ))}
                </Text>
              </View>
            </View>
            {!baby_registry_id && (
              <View style={styles.deliveryDate}>
                <PreOrderDeliveryDate date={preOrderDeliveryDate} />
              </View>
            )}
          </View>
        </View>
        {(Boolean(similarProducts.length) || similarProductsLoading) &&
        !baby_registry_id ? (
          <View>
            <Text style={styles.modalProductOtherText}>
              Barangkali kamu juga suka ini :
            </Text>
            {similarProductsLoading && (
              <View style={styles.productGridPlaceholder}>
                <ProductPlaceholder />
              </View>
            )}
            {similarProducts.length ? (
              isNative ? (
                <FlatList
                  contentContainerStyle={styles.productGridHorizontal}
                  data={similarProducts}
                  renderItem={renderItem}
                  keyExtractor={(item) => item._id}
                  horizontal={true}
                  showsHorizontalScrollIndicator={false}
                />
              ) : (
                <ProductSlider
                  data={similarProducts}
                  slideCount={isWeb ? 3 : 2}
                  maxWidth={isWeb ? maxContainer : 0}
                  containerStyle={isWeb ? styles.sliderPadding : {}}
                  maxWidthItem={isWeb ? maxItemContainer : 0}
                  renderItem={renderItem}
                />
              )
            ) : (
              false
            )}
          </View>
        ) : null}
        {!baby_registry_id && (
          <View style={styles.modalProductBottom}>
            <Button
              title="Continue Shopping"
              onPress={() => closeHandler()}
              containerStyle={[
                styles.containerButton,
                isWeb ? { marginRight: 16 } : {},
              ]}
              buttonStyle={styles.modalProductShoppingButtonContinue}
              titleStyle={styles.modalProductShoppingButtonTextContinue}
            />
            <Button
              title={'Go to Shopping Bag'}
              onPress={() => goToShoppingBag()}
              containerStyle={[
                styles.containerButton,
                isWeb ? { marginLeft: 16 } : {},
              ]}
              buttonStyle={styles.modalProductShoppingButtonShopping}
              titleStyle={styles.modalProductShoppingButtonTextShopping}
            />
          </View>
        )}
      </View>
    </Modalize>
  );
};

const styles = StyleSheet.create({
  modalProductWrapper: {
    paddingHorizontal: 16,
    paddingVertical: 20,
  },
  modalProductSummary: {
    flexDirection: 'row',
    backgroundColor: '#FAF8FC',
    borderRadius: 8,
    marginBottom: 16,
    ...(isWeb
      ? {
          paddingHorizontal: 38,
          paddingVertical: 15,
        }
      : {
          padding: 16,
        }),
  },
  modalProductSummaryBabyRegistry: {
    borderBottomWidth: 0,
  },
  modalProductSuccess: {
    backgroundColor: '#F3F0FC',
    flexDirection: 'row',
    ...(isWeb
      ? {
          justifyContent: 'flex-start',
          paddingHorizontal: 32,
          paddingVertical: 18,
        }
      : {
          paddingHorizontal: 28,
          paddingVertical: 22,
        }),
  },
  modalProductSuccessAdded: {
    backgroundColor: '#F3F0FC',
    paddingHorizontal: 28,
    paddingVertical: 40,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalProductSuccessBabyRegistry: {
    justifyContent: 'flex-start',
  },
  modalProductImage: {
    width: 64,
    height: 64,
    marginRight: 12,
    borderRadius: 8,
    overflow: 'hidden',
  },
  modalProductIconBag: {
    marginBottom: 6,
    width: 38,
    height: 50,
  },
  modalProductIconBagRegistry: {
    width: 48,
    height: 48,
    marginRight: 16,
  },
  modalProductInfo: {
    paddingTop: 4,
    paddingRight: 16,
    flex: 1,
  },
  modalProductBrand: {
    fontSize: 12,
    lineHeight: 16,
    ...Font.figtreeBlack,
    letterSpacing: 1.25,
    color: '#A775C8',
    marginBottom: isWeb ? 4 : 3,
    textTransform: 'uppercase',
  },
  modalProductName: {
    fontSize: 14,
    lineHeight: 20,
    ...Font.figtreeMedium,
    marginBottom: 6,
    color: Colors.purple7,
  },
  modalProductCombination: {
    fontSize: 12,
    lineHeight: 18,
    fontFamily: 'figtree-black',
    color: '#78707E',
  },
  modalProductCombinationValue: {
    fontFamily: 'figtree-medium',
  },
  modalProductCombinationGroup: {
    textTransform: 'capitalize',
  },
  handleStyle: {
    top: 26,
    backgroundColor: isWeb ? 'transparent' : '#D7CDF5',
    height: 3,
    width: 38,
  },
  modalStyle: {
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    overflow: 'hidden',
    ...(isWeb
      ? {
          width: maxContainer,
          margin: 'auto',
          borderRadius: 8,
        }
      : {}),
  },
  modalProductRegistry: {
    fontSize: 15,
    lineHeight: 18,
    ...Font.figtreeMedium,
    marginBottom: 6,
  },
  modalProductAdded: {
    fontSize: 20,
    ...Font.figtreeMedium,
    marginTop: 6,
  },
  modalProductShoppingButton: {
    borderRadius: 12,
    height: 24,
    width: 143,
    fontSize: 12,
    lineHeight: 16,
    paddingHorizontal: 0,
    letterSpacing: 0,
  },
  modalProductShoppingButtonText: {
    fontFamily: 'figtree-black',
    fontSize: 12,
    lineHeight: 13,
  },
  modalProductOtherText: {
    fontSize: 16,
    lineHeight: 20,
    fontFamily: 'figtree-black',
    color: Colors.purple7,
    marginBottom: 12,
    paddingHorizontal: 16,
  },
  productContainerStyle: isWeb
    ? { flexBasis: 'auto', paddingBottom: 0 }
    : { paddingBottom: 35 },
  productGridHorizontal: {
    paddingBottom: 24,
    paddingRight: 8,
  },
  productGridPlaceholder: {
    paddingLeft: 8,
  },
  modalProductClose: {
    position: 'absolute',
    top: 24,
    right: 15,
  },
  productBorderBottom: {
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
  },
  sliderPadding: { paddingHorizontal: 20 },
  deliveryDate: {
    bottom: isWeb ? 14 : 8,
    marginLeft: isWeb ? 25 : 0,
    marginRight: isWeb ? 50 : 0,
    marginVertical: isWeb ? 0 : 10,
  },
  modalProductBottom: {
    flexDirection: 'row',
    ...(isWeb
      ? {
          justifyContent: 'center',
        }
      : {
          justifyContent: 'space-between',
        }),
    alignItems: 'center',
    paddingHorizontal: 14,
    paddingBottom: 16,
  },
  modalProductShoppingButtonContinue: {
    borderRadius: 24,
    fontSize: 12,
    height: 40,
    ...(!isWeb
      ? {
          width: 170,
        }
      : {}),
    lineHeight: 16,
    paddingHorizontal: 0,
    letterSpacing: 0,
    backgroundColor: Colors.white,
    borderWidth: 1,
    borderColor: Colors.purple4,
  },
  modalProductShoppingButtonTextContinue: {
    fontFamily: 'figtree-black',
    fontSize: 14,
    lineHeight: 18,
    color: Colors.purple7,
  },
  modalProductShoppingButtonShopping: {
    borderRadius: 24,
    fontSize: 12,
    height: 40,
    ...(!isWeb
      ? {
          width: 170,
        }
      : {}),
    lineHeight: 16,
    paddingHorizontal: 0,
    letterSpacing: 0,
  },
  modalProductShoppingButtonTextShopping: {
    fontFamily: 'figtree-black',
    fontSize: 14,
    lineHeight: 18,
  },
  containerButton: {
    ...(isWeb
      ? {
          flex: 1,
        }
      : {}),
  },
});

export default ModalProductAdded;
